import cogoToast from 'cogo-toast';

const showToast = (state, message) => {
  if (state === 'error') {
    // make toaster persistent if state is error
    const { hide } = cogoToast.error(message, {
      position: 'bottom-right',
      hideAfter: 0,
      onClick: () => {
        hide();
      }
    });

    return;
  }

  return cogoToast[state](message, {
    position: 'bottom-right'
  });
};

export default showToast;
